import ComponentBasePrototype from 'ComponentBasePrototype';
import $ from 'jquery'
import Cookies from 'cookies'

/* globals grecaptcha */

const classNames = {
  displayNone: 'cms-huippudiili-number-offer__display-none',
  visibilityHidden: 'cms-huippudiili-number-offer__visibility-hidden',
  hasError: 'has-error',
  buttonDisabled: 'button--disabled',
  imageHeroBasicComponentNoMargin: 'image-hero__basic-components--no-margin',
};

const inputId = 'cms-huippudiili-number-offer__telephone-number-input-id'
const cookieDomainName = '.telia.fi'
const huippudiiliCookieName = 'huippudiili'

export default class HuippudiiliNumberOffer extends ComponentBasePrototype {
  build() {
    this.formContainer = this.node.find('.form-container')
    this.phoneNumberInput = this.node.find('.cms-huippudiili-number-offer__telephone-number-input')
    this.submitButton = this.node.find('.cms-huippudiili-number-offer__form-content button')
    this.inputValidationError = this.node.find('.cms-huippudiili-number-offer__telephone-number-input-error')
    this.loader = this.node.find('.cms-huippudiili-number-offer__loader')
    this.backendErrorNotification = this.node.find('.notification--backend-error')
    this.captchaTokenInput = this.node.find('.cms-huippudiili-number-offer__captcha-token')
    this.hideLoadingIcon = this.data.hideLoadingIcon
    this.showInputError = this.data.showInputError
    this.componentUsedInNewMagnoliaCard = this.data.componentUsedInNewMagnoliaCard
    document.getElementById(inputId).setAttribute('value', '')
    this.checkUsageOfComponent()
    // The number input could have a value if navigating back to this page
    this.toggleSubmitButtonBasedOnPhoneNumberValidityAndCaptcha()
    if (this.showInputError) {
      this.toggleInputValidationErrorBasedOnPhoneNumberValidity()
    }
    this.addSubmitButtonClickHandler()
    this.addPhoneNumberInputChangeHandler()
    this.addCaptchaTokenInputChangeHandler()
  }

  addSubmitButtonClickHandler() {
    this.submitButton.on('click', (event) => {
      event.preventDefault();
      if (this.isPhoneNumberValid() && this.captchaChecked()) {
        this.submitPhoneNumber()
      }
    })
  }

  getNormalizedPhoneNumber() {
    // Remove all whitespace
    let normalizedPhoneNumber = this.phoneNumberInput.val().replace(/\s/g, '')
    // Try to replace +358, the finnish country code with 0 if it's in the beginning of the number
    normalizedPhoneNumber = normalizedPhoneNumber.replace(/^\+358/g, '0')
    // Remove all +, (, ) and -
    normalizedPhoneNumber = normalizedPhoneNumber.replace(/[+()-]/g, '')
    return normalizedPhoneNumber
  }

  isPhoneNumberValid() {
    const phoneNumber = this.getNormalizedPhoneNumber()
    // Apparently the MIT backend only accepts numbers, NO whitespace, +, (, ) or - for example. Also no country codes, but we won't validate this.
    // From wikipedia.fi: "Matkaviestinverkon tilaajanumeron pituus on Suomessa 7–12 numeroa." (6 was requested ¯\_(ツ)_/¯)
    const isValid =
      phoneNumber.length >= 6 &&
      phoneNumber.length <= 12 &&
      phoneNumber.match('^[0-9]*$') != null
    return isValid
  }

  captchaChecked() {
    return !!this.captchaTokenInput.val()
  }

  submitPhoneNumber() {
    if (!this.hideLoadingIcon) {
      this.showLoader()
    }
    const phoneNumber = this.getNormalizedPhoneNumber()
    const redirectUrl = this.data.redirectUrl;
    this.setHuippudiiliNumberCookie(phoneNumber);
    this.hideLoader()
    window.location.href = redirectUrl;
  }

  setHuippudiiliNumberCookie(phoneNumber) {
    const cookieValue = {
      huippudiiliBackendCallExecutedFromOtherPage: true,
      huippudiiliNumber: phoneNumber,
    };
    const encryptedCookieValue = window.btoa(JSON.stringify(cookieValue))
    Cookies.set(huippudiiliCookieName, encryptedCookieValue, { expires: 300, domain: cookieDomainName });
  }

  hideInputValidationError() {
    this.phoneNumberInput.removeClass(classNames.hasError)
    this.inputValidationError.hide()
    if (this.componentUsedInNewMagnoliaCard) {
      this.submitButton.removeClass(classNames.visibilityHidden)
    } else {
      this.submitButton.removeClass(classNames.displayNone)
    }
  }

  showInputValidationError() {
    if (this.componentUsedInNewMagnoliaCard) {
      this.submitButton.addClass(classNames.visibilityHidden)
    } else {
      this.submitButton.addClass(classNames.displayNone)
    }
    this.phoneNumberInput.addClass(classNames.hasError)
    this.inputValidationError.show()
  }

  addPhoneNumberInputChangeHandler() {
    this.phoneNumberInput.on('input', () => {
      this.toggleSubmitButtonBasedOnPhoneNumberValidityAndCaptcha()
      this.blurInput(this.phoneNumberInput)
      if (this.showInputError) {
        this.toggleInputValidationErrorBasedOnPhoneNumberValidity()
      }
    })
    this.phoneNumberInput.one('input', () => {
      grecaptcha.execute().then(() => {
        window.setTimeout(() => {
          this.phoneNumberInput.focus()
        }, 400)
      })
    })
  }

  addCaptchaTokenInputChangeHandler() {
    this.captchaTokenInput.on('change', () => {
      this.toggleSubmitButtonBasedOnPhoneNumberValidityAndCaptcha()
    })
  }

  toggleSubmitButtonBasedOnPhoneNumberValidityAndCaptcha() {
    if (this.isPhoneNumberValid() && this.captchaChecked()) {
      this.enableSubmitButton()
    } else {
      this.disableSubmitButton()
    }
  }

  toggleInputValidationErrorBasedOnPhoneNumberValidity() {
    const shouldShowError = !this.isPhoneNumberValid() && this.phoneNumberInput.val()
    const phoneNumber = this.getNormalizedPhoneNumber()
    if ((phoneNumber.length < 6) && (phoneNumber.match('^[0-9]*$') != null)) {
      this.hideInputValidationError()
    } else if (shouldShowError) {
      this.showInputValidationError()
    } else {
      this.hideInputValidationError()
    }
  }

  disableSubmitButton() {
    this.submitButton.addClass(classNames.buttonDisabled)
    this.submitButton.prop('disabled', true)
  }

  enableSubmitButton() {
    this.submitButton.removeClass(classNames.buttonDisabled)
    this.submitButton.prop('disabled', false)
  }

  showLoader() {
    this.loader.show()
  }

  hideLoader() {
    this.loader.hide()
  }

  checkUsageOfComponent() {
    const usedInSplitHeroComponent = this.data.componentUsedInSplitHero
    if (usedInSplitHeroComponent) {
      this.node.parent().addClass(classNames.imageHeroBasicComponentNoMargin)
    }
  }

  blurInput(node) {
    const labelElement = node.parent().find('label');
    labelElement.removeClass('form__label--active');
    if (node.val()) {
      node.addClass('has-value');
      labelElement.addClass('has-value');
    } else {
      node.removeClass('has-value');
      labelElement.removeClass('has-value');
    }
  }

}